import { property } from "lit/decorators.js";
import { LeafElement } from "../leaf-element.js";
import "lit";
import "../../utilities/events.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class LeafSelectOption extends LeafElement {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.selected = false;
    this.value = "";
  }
}
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafSelectOption.prototype, "disabled", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafSelectOption.prototype, "selected", 2);
__decorateClass([
  property({ reflect: true })
], LeafSelectOption.prototype, "value", 2);
export {
  LeafSelectOption
};
//# sourceMappingURL=select-option.component.js.map
